import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './parcels.html'

/**
 * Parcels Report route
 *
 * @namespace routes.ReportParcels
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.parcels.list',
  label: 'REPORT.PARCELS.TITLE',
  url: '/parcels',
  component: 'tmrReportParcels',
  weight: 12,
  resourceType: 'Parcel',
  resourceList: {
    searchParameters: [
      'code',
      'creationDate.from',
      'creationDate.to',
      'receivedDate.from',
      'receivedDate.to',
      'completed',
      'received',
      'asn.originPlace.id',
      'asn.destinationPlace.id',
    ],
  },
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Resource.list', 'Resource.Parcel.list'],
  },
}

/**
 * Component for {@link routes.tmrReportParcels Parcels Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportParcels = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
